import { contour } from "./contour";

export function FooterContour() {
	return (
		<div className="w-full h-40 items-start overflow-hidden text-primary-accent bg-primary-background">
			{contour()}
		</div>
	);
}
